import { makeStyles } from '@material-ui/core/styles';


export const PanelScaleSettingsStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },

  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 190,
  },
  buttonProgress: {
    color: 'primary',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
    marginTop: '7%'
  },
  rootList: {
    width: '100%',
    backgroundColor: "#f5f5f5",
  },
  titleList: {
    textAlign: "center",
    margin: "0 auto",
    padding: 5,
    color: "black",
    fontSize: 15
  },
}));